import PreviewUnit from '../section/units/PreviewUnit';
import ArticleHeaderUnit from '../section/units/ArticleHeaderUnit';
import SectionHeaderUnit from '../section/units/SectionHeaderUnit';
import TextUnit from '../section/units/TextUnit';
import { getTitleMetrics, getSubMetrics } from '../section/units/metrics/HeaderMetrics';
import {
    getTitleMetrics as getFooterTitleMetrics, getTextMetrics as getFooterTextMetrics
} from '../section/units/metrics/FooterMetrics';
import {
    getTitleMetrics as getSectionTitleMetrics, getMajorTitleMetrics as getSectionMajorTitleMetrics, getSubMetrics as getSectionSubMetrics
} from '../section/units/metrics/SectionHeaderMetrics';
import {
    getTitleMetrics as getARFilterTitleMetrics, getSocialMetrics as getARFilterSocialMetrics
} from '../section/units/metrics/ARFilterMetrics';
import UnitTypes from '../../../constants/UnitTypes';
import AbstractUnit from '../section/units/AbstractUnit';
import ObjectUnit from '../section/units/ObjectUnit';
import ARFilterPreviewUnit from '../section/units/ARFilterPreviewUnit';
import FooterUnit from '../section/units/FooterUnit';

export const ContentUnitFactory = {
    create(type, data, webgl) {
        let obj3D = null;

        switch (type) {
            case UnitTypes.PREVIEW:
                obj3D = new PreviewUnit(data, webgl, false);

                break;

            case UnitTypes.HEADER:
                obj3D = new ArticleHeaderUnit(data, webgl, {
                    needIndex: false,
                    needArticleHeaderResize: true,
                    getTitleMetrics,
                    getSubMetrics
                }, false);

                break;

            case UnitTypes.FOOTER:
                obj3D = new FooterUnit(data, webgl, {
                    getTitleMetrics: getFooterTitleMetrics,
                    getPrefixMetrics: getFooterTextMetrics,
                    getLinkMetrics: getFooterTextMetrics
                }, false);

                break;

            case UnitTypes.SECTION_HEADER:
                obj3D = new SectionHeaderUnit(data, webgl, {
                    needIndex: true,
                    getTitleMetrics: data.isMajor ? getSectionMajorTitleMetrics : getSectionTitleMetrics,
                    getSubMetrics: getSectionSubMetrics
                }, false);

                break;

            case UnitTypes.TEXT:
                obj3D = new TextUnit(data, webgl, false);

                break;

            case UnitTypes.OBJECT:
                obj3D = new ObjectUnit(data, webgl, false);

                break;

            case UnitTypes.AR_FILTER:
                obj3D = new ARFilterPreviewUnit(data, webgl, {
                    getTitleMetrics: getARFilterTitleMetrics,
                    getSocialMetrics: getARFilterSocialMetrics
                }, false);

                break;

            default:
                obj3D = new AbstractUnit(data, webgl, null, false);

                break;
        }

        return obj3D;
    }
};
